import { TENANTS } from "../constants"
import { LOG_LEVELS } from "../constants/LogLevels"
import { getCountryFromLanguage, sendToLogServer } from "../core/service/BusinessLogicService"
import { isItalianTenant } from "../core/utils"
import { digitalJourneyApigateway } from "../intances/apigateway"

/**
 * getOptinsByTenantAndCountry() gets the optins from the API
 * @param tunnelData - data of journey
 */
export function getOptinsByTenantAndCountry(tunnelData) {
  const { tenant, data } = tunnelData

  const countryCode = getCountryFromLanguage(data.order.orderLanguageTag)

  // for italian tenant (personalrenting) optins, we use samsung_it config for the API call
  const tenantToUseInAPI = isItalianTenant(tenant) ? TENANTS.SAMSUNG_IT : tenant

  const params = new URLSearchParams()
  params.append("tenant", tenantToUseInAPI)
  params.append("countryCode", countryCode)

  const API_URL = `middle-business-service/api/v2/repository/optins?`

  return digitalJourneyApigateway(tunnelData)
    .get(API_URL + params)
    .then((response) => {
      const { data } = response
      const checkBoxOptins = data.filter((o) => o.type.toLowerCase() === "checkbox")
      const radioOptins = data.filter((o) => o.type.toLowerCase() === "radio")

      if (tunnelData.tenant === TENANTS.PROXY_CYCLE) {
        return checkBoxOptins.concat(radioOptins)
      }
      return checkBoxOptins.concat(radioOptins).sort((optin) => {
        return optin.required ? 0 : -1
      })
    })
    .catch((error) => {
      sendToLogServer(
        LOG_LEVELS.ERROR,
        `An error occured when retrieving optins by tenant and country code, error message => ${error.message}`
      )
      throw error
    })
}
